<template>
  <div class="pratos-container" :class="{'visible':visible}">
    <div class="pt-header">
      <span v-text="$t('required_restriction')"></span>
      <span v-text="$t('subtitle_monday')"></span>
      <span v-text="$t('subtitle_tuesday')"></span>
      <span v-text="$t('subtitle_wednesday')"></span>
      <span v-text="$t('subtitle_thursday')"></span>
      <span v-text="$t('subtitle_friday')"></span>
      <span v-text="$t('subtitle_saturday')"></span>
      <span v-text="$t('subtitle_sunday')"></span>
      <span v-text="$t('subtitle_first_week')"></span>
      <span v-text="$t('subtitle_second_week')"></span>
      <span v-text="$t('subtitle_third_week')"></span>
      <span v-text="$t('subtitle_fourth_week')"></span>
      <span v-text="$t('subtitle_last_week')"></span>
      <span v-text="$t('subtitle_holiday')"></span>
    </div>    
    <div class="pt-body">
      <div class="pratos" v-if="grupo">
        <span v-text="grupo.nm_grupo"></span>
        <span v-text="getUtilSymbol(grupo.id_segunda)"></span>
        <span v-text="getUtilSymbol(grupo.id_terca)"></span>
        <span v-text="getUtilSymbol(grupo.id_quarta)"></span>
        <span v-text="getUtilSymbol(grupo.id_quinta)"></span>
        <span v-text="getUtilSymbol(grupo.id_sexta)"></span>
        <span v-text="getUtilSymbol(grupo.id_sabado)"></span>
        <span v-text="getUtilSymbol(grupo.id_domingo)"></span>
        <span v-text="getUtilSymbol(grupo.id_semana_1)"></span>
        <span v-text="getUtilSymbol(grupo.id_semana_2)"></span>
        <span v-text="getUtilSymbol(grupo.id_semana_3)"></span>
        <span v-text="getUtilSymbol(grupo.id_semana_4)"></span>
        <span v-text="getUtilSymbol(grupo.id_utl_semana)"></span>
        <span v-text="getUtilSymbol(grupo.id_feriado)"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnalResultPrato",
  props: ["grupo", "visible"],
  data() {
    return {};
  },
  methods: {
    getUtilSymbol: function(ut){
      return ut === 'O'? "✔" : ut === 'R' ? "Ø" : " ";
    }
  },
  watch: {
    visible: function() {
      this.visible;
    }
  }
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");
@size: calc((100% - 47%) / 13);
.pratos-container {
  .sombra;
}
.pt-header {
  background: @azul;
  color: #fff;
  display: grid;
  
  grid-template-columns:
    47% @size @size @size
    @size @size @size @size
    @size @size @size @size @size @size;
    span{
      padding: 5px 0;
    }
  span:first-of-type {
    padding-left: 5px;
  }
  span:not(:first-of-type) {
    text-align: center;
  }
}
.pt-body {
  max-height: 200px;
  overflow: auto;
  .pratos {
    cursor: default;
    &:nth-of-type(2n) {
      background: rgba(196, 196, 196, 0.2);
    }
    display: grid;
    grid-template-columns:
      47% @size @size @size
    @size @size @size @size
    @size @size @size @size @size @size;
    span{
      padding: 5px 0;
      font-size: 13px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    span:first-of-type {
      padding-left: 5px;
    }
    span:not(:first-of-type) {
      text-align: center;
    }
  }
}
</style>